import {
  useRouteMatch,
  useHistory,
  useLocation,
  useParams
} from 'react-router-dom'
import { useIntercom } from 'react-use-intercom'
import { deserializeQueryString } from './urlManager'

export function withHistory(Component) {
  return (props) => <Component {...props} history={useHistory()} />
}

export function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />
}

export function withLocation(Component) {
  return (props) => (
    <Component
      {...props}
      location={useLocation()}
      urlQuery={deserializeQueryString(useLocation().search)}
    />
  )
}

export function withRouteMatch(Component) {
  return (props) => <Component {...props} match={useRouteMatch()} />
}

export function withUseIntercom(Component) {
  return (props) => <Component {...props} useIntercom={useIntercom()} />
}

export function withRouter(Component) {
  return (props) => (
    <Component
      {...props}
      history={useHistory()}
      location={useLocation()}
      match={useRouteMatch()}
      params={useParams()}
      urlQuery={deserializeQueryString(useLocation().search)}
    />
  )
}
